
export const scrollToTopOfAccountPage = () => {
    const elem = document.getElementsByClassName('accountsModal');
    if(elem && elem.length >= 1) {
        elem[0].querySelector('.modal__content').scrollTo(0,0);
    }
};

export const scrollToTopOfContentPage = () => {
    const elem = document.getElementsByClassName('nuContent');
    if(elem && elem.length >= 1) {
        elem[0].querySelector('.modal__body').scrollTo(0,0);
    }
};
